import { FC } from 'react';
import * as S from './styles';

interface IMenu {
  shouldShow: boolean;
  children: any;
  innerRef: React.MutableRefObject<null>;
}

export const Menu: FC<IMenu> = ({ shouldShow, children, innerRef }) => {
  return (
    <S.Menu shouldDisplay={shouldShow} ref={innerRef}>
      {children}
    </S.Menu>
  );
};
